import React from 'react';
import { Shield, Hand, Radio, Radar, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { safetyLevels } from '../mock';

export const Securite = () => {
  const iconMap = {
    hand: Hand,
    radio: Radio,
    radar: Radar
  };

  return (
    <div className="securite-page">
      {/* Header */}
      <section className="page-header security-header">
        <div className="container">
          <Shield className="header-icon" size={64} />
          <h1 className="page-title">Sécurité Triple Niveau</h1>
          <p className="page-description">
            Notre système de sécurité révolutionnaire protège les personnes et respecte les chevaux.
          </p>
        </div>
      </section>

      {/* Main Security System */}
      <section className="security-system-section">
        <div className="container">
          <div className="security-intro">
            <h2 className="section-title">Comment Ça Marche ?</h2>
            <p className="intro-text">
              Nos attelages intègrent trois niveaux de sécurité complémentaires qui permettent
              de libérer instantanément le cheval en cas de problème. Aucun stress pour l'animal,
              sécurité maximale pour les personnes.
            </p>
          </div>

          <div className="security-levels-detailed">
            {safetyLevels.map((level, index) => {
              const IconComponent = iconMap[level.icon];
              return (
                <div key={level.id} className={`security-level-detail ${index % 2 === 1 ? 'reverse' : ''}`}>
                  <div className="level-visual">
                    <div className="level-icon-wrapper">
                      <IconComponent size={80} className="level-icon" />
                      <div className="level-number-badge">Niveau {level.id}</div>
                    </div>
                  </div>
                  <div className="level-content">
                    <h3 className="level-title">{level.title}</h3>
                    <p className="level-description">{level.description}</p>
                    <div className="level-benefits">
                      <div className="benefit">
                        <CheckCircle2 size={20} className="benefit-icon" />
                        <span>Activation instantanée</span>
                      </div>
                      <div className="benefit">
                        <CheckCircle2 size={20} className="benefit-icon" />
                        <span>Zéro stress pour le cheval</span>
                      </div>
                      <div className="benefit">
                        <CheckCircle2 size={20} className="benefit-icon" />
                        <span>Testé en conditions réelles</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why It's Unique */}
      <section className="unique-section">
        <div className="container">
          <h2 className="section-title">Pourquoi Notre Système Est Unique</h2>
          <div className="unique-grid">
            <Card className="unique-card">
              <CardContent className="unique-card-content">
                <Shield className="unique-icon" size={40} />
                <h3 className="unique-title">Triple Redondance</h3>
                <p className="unique-description">
                  Trois systèmes indépendants garantissent une sécurité sans faille,
                  même en cas de défaillance d'un système.
                </p>
              </CardContent>
            </Card>
            <Card className="unique-card">
              <CardContent className="unique-card-content">
                <AlertTriangle className="unique-icon" size={40} />
                <h3 className="unique-title">Détection Automatique</h3>
                <p className="unique-description">
                  Le distancemètre détecte automatiquement une chute ou un éloignement
                  du meneur et déclenche la libération.
                </p>
              </CardContent>
            </Card>
            <Card className="unique-card">
              <CardContent className="unique-card-content">
                <CheckCircle2 className="unique-icon" size={40} />
                <h3 className="unique-title">Bien-être Animal</h3>
                <p className="unique-description">
                  Libération douce et progressive qui évite tout stress ou panique
                  pour le cheval.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Benefits for Horses */}
      <section className="horse-benefits-section">
        <div className="container">
          <h2 className="section-title">Bénéfices pour les Chevaux</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <CheckCircle2 className="benefit-check" size={32} />
              <div>
                <h3 className="benefit-title">Pas de panique</h3>
                <p className="benefit-text">
                  La libération progressive évite toute réaction de peur ou de fuite.
                </p>
              </div>
            </div>
            <div className="benefit-item">
              <CheckCircle2 className="benefit-check" size={32} />
              <div>
                <h3 className="benefit-title">Léger et maniable</h3>
                <p className="benefit-text">
                  Nos attelages sont conçus pour être légers et équilibrés, minimisant l'effort du cheval.
                </p>
              </div>
            </div>
            <div className="benefit-item">
              <CheckCircle2 className="benefit-check" size={32} />
              <div>
                <h3 className="benefit-title">Attelage confortable</h3>
                <p className="benefit-text">
                  Distribution optimale du poids et harnachement adapté pour le confort maximal.
                </p>
              </div>
            </div>
            <div className="benefit-item">
              <CheckCircle2 className="benefit-check" size={32} />
              <div>
                <h3 className="benefit-title">Testé en conditions réelles</h3>
                <p className="benefit-text">
                  Nos systèmes ont été testés sur différents terrains avec des chevaux de toutes tailles.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Securite;
